<template lang="pug">
    Wistia(v-if="video.type.toLowerCase() == 'wistia'" :video="video" :autoPlay="autoPlay")
    YouTube(v-else :video="video" :autoPlay="autoPlay")
</template>
<script>
// This comp represents a responsive video player that takes up as much room as you give it.
// It's a proxy comp in that you give it a vid obj and it will render the appropriate player

import Wistia from '@/integrations/wistia/video'
import YouTube from '@/integrations/youtube/video'

export default {
    components: {
        Wistia,
        YouTube,
    },
    props: {
        video: {
            type: Object,
            required: true,
            validator(obj) {
                return ['youtube', 'wistia'].includes(obj.type.toLowerCase())
            },
        },
        autoPlay: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
